import { useState } from 'react';
import { useCreateEmojis, useCreateImages, } from '@tribeplatform/react-sdk/hooks';
import { mergeArrayByKey } from '../../common/utils/array.utils';
import { getFileReader } from '../../Composer/utils/filereader';
export const useHandleUploadableMedia = ({ defaultValue, multiple, onChange, onError, }) => {
    const { mutateAsync: createImages, isLoading: isImagesLoading } = useCreateImages({
        useMutationOptions: {
            onError,
        },
    });
    const { mutateAsync: createEmojis, isLoading: isEmojisLoading } = useCreateEmojis();
    const [images, setImages] = useState(defaultValue);
    const onImageUpload = async (files) => {
        var _a, _b, _c, _d;
        if (!(files === null || files === void 0 ? void 0 : files.length))
            return null;
        if (!multiple) {
            files = files.slice(0, 1);
        }
        const tempImageData = await Promise.all(files.map(async (file) => {
            const fileSrc = await getFileReader(file);
            return {
                name: file.name,
                file,
                isLoading: true,
                url: fileSrc.url,
            };
        }));
        setImages(images => multiple ? mergeArrayByKey(images, tempImageData, 'name') : tempImageData);
        try {
            const uploadedImages = await createImages(files.map(file => ({
                name: file.name,
                file,
            })));
            const updatedImages = multiple
                ? mergeArrayByKey(images, uploadedImages, 'name')
                : uploadedImages;
            setImages(updatedImages);
            onChange(updatedImages);
        }
        catch (error) {
            // Revert back
            const updatedImages = [...images.filter(a => !a.isLoading)];
            setImages(updatedImages);
            onChange(updatedImages);
            const message = ((_d = (_c = (_b = (_a = error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.map(e => e.message)) === null || _d === void 0 ? void 0 : _d.join('\n')) || error.message;
            onError({
                fileName: '',
                message,
            });
        }
    };
    const onEmojiChange = async (emoji) => {
        var _a, _b, _c, _d;
        try {
            const uploadedEmoji = await createEmojis([{ text: emoji === null || emoji === void 0 ? void 0 : emoji.id }]);
            setImages(uploadedEmoji);
            onChange(uploadedEmoji);
        }
        catch (error) {
            const message = ((_d = (_c = (_b = (_a = error) === null || _a === void 0 ? void 0 : _a.response) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.map(e => e.message)) === null || _d === void 0 ? void 0 : _d.join('\n')) || error.message;
            onError({
                fileName: '',
                message,
            });
        }
    };
    const onRemove = (image) => {
        const updatedImages = [...images.filter(it => it.id !== image.id)];
        setImages(updatedImages);
        onChange(updatedImages);
    };
    return {
        medias: images,
        isLoading: isImagesLoading || isEmojisLoading,
        onImageUpload,
        onEmojiChange,
        onRemove,
    };
};
//# sourceMappingURL=useHandleUploadableMedia.js.map